import React, { useState, useCallback } from 'react';
import { FormChangeContext } from './useFormChange';

interface FormChangeProviderProps {
  children: React.ReactNode;
}

export const FormChangeProvider: React.FC<FormChangeProviderProps> = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const resetFormState = useCallback(() => {
    setHasUnsavedChanges(false);
  }, []);

  return (
    <FormChangeContext.Provider value={{
      hasUnsavedChanges,
      setHasUnsavedChanges,
      resetFormState
    }}>
      {children}
    </FormChangeContext.Provider>
  );
};
